import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PlannerBoardComponent } from './planner-board.component';

const routes: Routes = [{
    path: 'board',
    component: PlannerBoardComponent
}];


export class PlannerBoardRoutingModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
